"use client";

import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { InvestorLists } from "../utils/get-investor-list";

type Props = {
  id: number;
  data: InvestorLists[0];
  isActive: boolean;
};

export const FamousInvestorButton = ({ id, data, isActive }: Props) => {
  const { updateQuery } = useUpdateQuery();

  return (
    <button
      className={twMerge(
        "group flex w-full cursor-pointer items-center justify-between rounded-md px-6 py-2 text-sm font-bold text-zinc-500 transition-colors hover:bg-sky-50 hover:text-sky-700",
        data.isDisable &&
          "pointer-events-none cursor-auto select-none text-zinc-300",
        isActive && "bg-sky-50 text-sky-700"
      )}
      disabled={data.isDisable}
      onClick={() => {
        updateQuery({ name: "famous", value: id.toString() });
      }}
    >
      <span className="whitespace-nowrap text-left">{data.investorName}</span>
      <ChevronRightIcon
        className={twMerge(
          "-mr-2 hidden h-4 w-4 shrink-0 group-hover:inline-block",
          isActive && "inline-block"
        )}
      />
    </button>
  );
};
